<template>
  <l-button
    :class="[
      'bg-transparent inline-flex gap-2 items-center border-0 rounded p-1 leading-none md:px-2',
      { 'hover:bg-gray-400/10': showLabel },
    ]"
    :title="inList ? 'Remove school from your list' : 'Save school to your list'"
    requires-auth
    @click="toggleSchool"
  >
    <i :class="[inList ? 'fa-solid' : 'fa-light', 'fa-star text-yellow']"/>
    <span v-if="showLabel" class="text-base hidden mt-px md:inline-block" v-text="inList ? 'Saved' : 'Save'"/>
  </l-button>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"
import { api } from "@/api"
import { computed } from "vue"
import { toast } from "@/notifications"

const school = defineModel({ type: Object, required: true })

defineProps({
  showLabel: { type: Boolean },
})

const inList = computed(() => {
  return school.value.in_list
})

const addSchool = () => {
  api.listAdd(school.value.id).then(() => {
    const newSchool = {
      ...school.value,
      in_list: true,
    }
    school.value = newSchool
    toast.info("Saved school to your list", { iconHtml: "<i class=\"text-xl fa-solid fa-star text-yellow\"/>" })
  }).catch(() => {
    toast.error("Error adding school to your list", { iconHtml: "<i class=\"text-xl fa-light fa-star text-yellow\"/>" })
  })
}

const removeSchool = () => {
  api.listRemove(school.value.id).then(() => {
    const newSchool = {
      ...school.value,
      in_list: false,
    }
    school.value = newSchool
    toast.info("Removed school from your list", { iconHtml: "<i class=\"text-xl fa-light fa-star text-yellow\"/>" })
  }).catch(() => {
    toast.error("Error removing school from your list", { iconHtml: "<i class=\"text-xl fa-solid fa-star text-yellow\"/>" })
  })
}

const toggleSchool = () => {
  if (!inList.value) {
    addSchool()
  } else {
    removeSchool()
  }
}
</script>
